export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        itemId: entity.itemId,
        posItemId: entity.posItemId,
        price: entity.price,
        sortIndex: entity.sortIndex,
        meta: entity.meta
    };
};
